/**
 * The type of redux action dispatched which represents that the brightness
 * adjustment effect is enabled or not.
 *
 * @returns {{
 *     type: SET_BRIGHTNESS_ENABLED,
 *     enabled: boolean
 * }}
 */
export const SET_BRIGHTNESS_ENABLED = 'SET_BRIGHTNESS_ENABLED';
